<template>
  <div
    class="m-dropdown-content m-dropdown-content-right m-the-header-sub-menu-dropdown-user"
    id="MoleculeTheHeaderSubMenuDropDownUser"
  >
    <header class="m-dropdown-header">
      <span class="ellipsis m-dropdown-title text-color-vidroop-primary">
        {{ nombre }}
      </span>
      <span class="ellipsis m-dropdown-subtitle">
        {{ email }}
      </span>
    </header>
    <section class="m-dropdown-section">
      <ul class="m-dropdown-list">
        <li>
          <router-link
            :to="`/${$t('rPaths.account')}/${$t('mEditionMenu.account.profile.subject')}`"
            @click.native="$dropDown.closeDropDown('MoleculeTheHeaderSubMenuDropDownUser')"
          >
            <span class="m-dropdown-item-icon">
              <i class="far fa-smile text-color-account-primary"></i>
            </span>
            <span class="m-dropdown-item-text">
              {{ $t('mTheHeaderSubMenuDropDownUser.options.account') }}
            </span>
          </router-link>
        </li>
        <li>
          <router-link
            :to="`/${$t('rPaths.account')}/${$t('mEditionMenu.account.security.subject')}`"
            @click.native="$dropDown.closeDropDown('MoleculeTheHeaderSubMenuDropDownUser')"
          >
            <span class="m-dropdown-item-icon">
              <i class="far fa-lock-alt text-color-account-primary"></i>
            </span>
            <span class="m-dropdown-item-text">
              {{ $t('mTheHeaderSubMenuDropDownUser.options.security') }}
            </span>
          </router-link>
        </li>
        <li>
          <router-link
            :to="`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.myPayments.subject')}`"
            @click.native="$dropDown.closeDropDown('MoleculeTheHeaderSubMenuDropDownUser')"
          >
            <span class="m-dropdown-item-icon">
              <i class="far fa-play-circle text-color-billing-primary"></i>
            </span>
            <span class="m-dropdown-item-text">
              {{ $t('mTheHeaderSubMenuDropDownUser.options.payments') }}
            </span>
          </router-link>
        </li>
        <li v-if="canAccessUniversity">
          <a
            :href="$utils.getUniversityDomain()"
            target="_blank"
          >
            <span class="m-dropdown-item-icon">
              <i class="far fa-university text-color-assets-primary"></i>
            </span>
            <span class="m-dropdown-item-text">
              {{ $t('mTheHeaderSubMenuDropDownUser.options.university') }}
            </span>
          </a>
        </li>
        <li v-if="academiasUsuario.length > 1">
          <a
            href="#"
            @click.stop.prevent="$dropDown.switchDropDown('MoleculeTheHeaderSubMenuDropDownAcademies')"
          >
            <span class="m-dropdown-item-icon">
              <i class="far fa-sync-alt font-size-medium text-color-academy-primary"></i>
            </span>
            <span class="m-dropdown-item-text">
              {{ $t('mTheHeaderSubMenuDropDownUser.options.changeAcademy') }}
            </span>
          </a>
        </li>
        <li>
          <router-link
            to="/logout"
          >
            <span class="m-dropdown-item-icon">
              <i class="far fa-arrow-alt-right text-color-danger"></i>
            </span>
            <span class="m-dropdown-item-text">
              {{ $t('mTheHeaderSubMenuDropDownUser.options.logout') }}
            </span>
          </router-link>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
export default {
  name: 'MoleculeTheHeaderSubMenuDropDownUser',

  props: {
    academiasUsuario: Array,
    usuario: Object
  },

  computed: {
    academia () {
      return this.$store.getters.getAcademyData
    },

    canAccessUniversity () {
      return this.usuario.vidroop_data.id === this.academia.licencia.usuario
    },

    email () {
      return this.usuario.email
    },

    nombre () {
      return this.usuario.vidroop_data &&
        this.usuario.vidroop_data.persona &&
        this.usuario.vidroop_data.persona.razon_social
        ? this.usuario.vidroop_data.persona.razon_social
        : this.usuario.email
    }
  }
}
</script>
